import * as Sentry from "@sentry/react";

import { ConfigService } from "@/shared/services/config.service";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string,
  environment: (import.meta.env.VITE_ENV as string) ?? "production",
  enabled: import.meta.env.VITE_ENV !== "development",

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],

  tracesSampleRate: import.meta.env.VITE_ENV === "production" ? 0.2 : 1.0,
  // The API this host actually calls, which is not always `VITE_COLOCA_API` (see `resolveApiUrlForHost`).
  tracePropagationTargets: [
    ConfigService.getInstance().get("colocaApiUrl") as string,
    import.meta.env.VITE_COLOCA_URL_PAYIN_PIX as string,
  ],

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});
